import React from "react";
import FooterSocial from "./components/footer/FooterSocial";
import FooterNav from "./components/footer/FooterNav";

export default function Footer() {
  return (
    <footer
      id="contact"
      className="relative z-10 mt-24 border-t-2 border-current bg-[hsl(var(--foreground))] text-[hsl(var(--background))]"
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <div className="eyebrow text-[hsl(var(--primary))] mb-3">A NewWaysToday Project</div>
          <h3 className="font-display uppercase font-bold text-3xl md:text-5xl leading-[0.9] tracking-tight">
            Reach.<br />Reproduce.<br />Repeat.
          </h3>
          <p className="font-body mt-6 max-w-md text-lg opacity-80 leading-relaxed">
            This book belongs to everyone. Print it. Email it. Read it aloud.
            The Hundredth Monkey can only happen if you are one of the monkeys.
          </p>
        </div>

        <div>
          <div className="eyebrow text-[hsl(var(--primary))] mb-3">Contact</div>
          <a
            href="mailto:ProfessorKnowOne@gmail.com"
            className="font-display font-bold uppercase text-xl md:text-2xl break-words hover:text-[hsl(var(--primary))] transition-colors"
            data-testid="footer-contact-email"
          >
            ProfessorKnowOne<span className="opacity-50">@</span>gmail.com
          </a>
          <p className="font-body opacity-70 mt-4 text-base">
            Letters from would-be hundredth-monkeys welcome.
          </p>
        </div>

        <FooterSocial />
        <FooterNav />
      </div>

      <div className="border-t border-current/30">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-wrap items-center justify-between gap-4 font-display uppercase tracking-widest text-xs opacity-70">
          <span>© NewWaysToday · in service of awareness</span>
          <span>Ken Keyes Jr. · Vision Books · 1981</span>
        </div>
      </div>
    </footer>
  );
}
